


<div class="modern-container container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="fas fa-user-shield"></i>
      </div>
      <div class="header-text">
        <h1 class="page-title">Grievance Redressal Portal</h1>
        <p class="page-subtitle">Lodge and track your grievances efficiently</p>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="user-actions">
        <small class="welcome-text" *ngIf="username"><i class="fas fa-user-circle"></i> Hi, {{username}}</small>
        <button class="btn btn-modern btn-login" data-bs-toggle="modal" data-bs-target="#exampleModal" *ngIf="!username">
          <i class="fas fa-sign-in-alt"></i> Login
        </button>
        <button class="btn btn-modern btn-logout" (click)="logout()" *ngIf="username">
          <i class="fas fa-sign-out-alt"></i> Logout
        </button>
      </div>
    </div>

    <div class="col-lg-12">
        <ul class="modern-tabs nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="home-tab" data-bs-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">
                <i class="fas fa-home"></i> Home
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="profile-tab" data-bs-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
                <i class="fas fa-file-alt"></i> My Portal
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="history-tab" data-bs-toggle="tab" href="#history" role="tab" aria-controls="history" aria-selected="false">
                <i class="fas fa-history"></i> History
              </a>
            </li>
          </ul>
         
          <div class="tab-content modern-tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
              <div class="modern-card card">
                    <div class="card-body">
                      <h5 class="card-title"><i class="fas fa-info-circle"></i> Mechanism for Grievances Redressal</h5>
                      <hr class="title-divider">
                      <p class="card-text">
                          College of Pharmacy has created a mechanism for redressal of student's grievances related to academic and non-academic matters, such as assessment, victimization, attendance, charging of fees, conducting of examinations, harassment by colleague students or teachers etc. There are Grievance Redressal Committees at the Programme/Institute/University levels to deal with the grievances of the students.
                      </p>
                    </div>
                  </div>
            </div>
            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                <div class="modern-card card">
                    <div class="card-body">
                      <h5 class="card-title"><i class="fas fa-edit"></i> Lodge your Grievance</h5>
                      <hr class="title-divider">
                      <app-add (command)="requestForUpdate($event)"></app-add>
                    </div>
                  </div>
            </div>
            <div class="tab-pane fade" id="history" role="tabpanel" aria-labelledby="history-tab">
                <app-student-history [historyList]="complaintList" [isLoggedIn]="this.isLoggedIn" ></app-student-history>
            </div>
          </div>

    </div>
  </div>
</div>
  
  <!-- Modal -->
  <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Login</h5>
          <button id="popupclose" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
        <app-login (user)="manageProfile($event)"></app-login>
        </div>
      </div>
    </div>
  </div>